import { render } from "./VelocityChart.vue?vue&type=template&id=345b23ea&scoped=true"
import script from "./VelocityChart.vue?vue&type=script&lang=js"
export * from "./VelocityChart.vue?vue&type=script&lang=js"

import "./VelocityChart.vue?vue&type=style&index=0&id=345b23ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345b23ea"]])

export default __exports__